export const LEADS_DATA_SOURCE = 'leads';
export const INTERVENE_DATA_SOURCE = 'InterveneMessageAnalytics';

export const normalizeReportScope = (scopeOrLeadFormId) => {
  if (scopeOrLeadFormId && typeof scopeOrLeadFormId === 'object') {
    return { ...scopeOrLeadFormId };
  }
  return scopeOrLeadFormId === undefined || scopeOrLeadFormId === null || scopeOrLeadFormId === ''
    ? {}
    : { leads_form_id: scopeOrLeadFormId };
};

export const buildReportScopeQuery = (scopeOrLeadFormId, extra = {}) => {
  const scope = { ...normalizeReportScope(scopeOrLeadFormId), ...extra };
  return Object.entries(scope)
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join('&');
};

export const getReportDataSource = (template) =>
  template?.data_source === INTERVENE_DATA_SOURCE
    ? INTERVENE_DATA_SOURCE
    : LEADS_DATA_SOURCE;

export const getAuthenticatedOrganisationId = (user) =>
  user?.profile?.organisation?.organisation_id ||
  user?.profile?.organisation_id ||
  user?.organisation_id ||
  '';

export const buildScopedReportPayload = ({
  template,
  leadsFormId,
  organisationId,
  charts,
}) => {
  const dataSource = getReportDataSource(template);
  const payload = {
    ...template,
    charts: charts ?? template?.charts ?? [],
    format: 'html',
  };

  if (dataSource === INTERVENE_DATA_SOURCE) {
    delete payload.leads_form_id;
    return {
      ...payload,
      data_source: INTERVENE_DATA_SOURCE,
      scope_type: 'organisation',
      organisation_id: organisationId,
    };
  }

  delete payload.data_source;
  delete payload.scope_type;
  delete payload.organisation_id;
  return { ...payload, leads_form_id: leadsFormId };
};
